import { Injectable } from '@angular/core';
import { Globals } from '../providers/globals';

@Injectable()
export class Utils {
	newguid(){
		var newguid="";

		for (var i=0; i<32; i++){
			newguid += Math.floor(Math.random()*0xF).toString(0xF);
		}

		return newguid;
	}		
		
	generateRandomNonZero5DigitNumber() {
		let randomNumber;
		do {
			// Generate a random number between 10000 and 99999 (both inclusive)
			randomNumber = Math.floor(Math.random() * 90000) + 10000;
		} while (randomNumber === 10000); // Repeat until the number is not 10000

		return randomNumber;
	}		
			
	today() { 
		var currentdate = new Date(); 
		var datetime =    currentdate.getDate() + "/"
		                + (currentdate.getMonth()+1)  + "/" 
		                + currentdate.getFullYear() + " @ "  
		                + currentdate.getHours() + ":"  
		                + currentdate.getMinutes() + ":" 
		                + currentdate.getSeconds();
		return datetime;		          
	}

	todayDateTime() { 
		var currentdate = new Date(); 
		var datetime =    currentdate.getFullYear() + "-"
		                + (currentdate.getMonth()+1)  + "-" 
		                + currentdate.getDate() + "T"  
		                + currentdate.getHours() + ":"  
		                + currentdate.getMinutes() + ":" 
		                + currentdate.getSeconds();
		return datetime;		          
	}

	days: any = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

	dayIndexToName(date){
		var dayName = this.days[date.getDay()];	

		return dayName;
	}

	timeConvert (time) {
		// Check correct time format and split into components
		time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

		if (time.length > 1) { // If time format correct
		time = time.slice (1);  // Remove full string match value
		time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
		time[0] = +time[0] % 12 || 12; // Adjust hours
		}
		return time.join (''); // return adjusted time or original string
	}	

	getMilliseconds(dateStr){
		return new Date(dateStr).getTime();
	}

	formatTime(dateStr){
		return (new Date(dateStr)).toLocaleTimeString();
	}	

	daysLeftText(date){
		var date1 = new Date(date);
		var today = new Date();

		var timeDiff = Math.abs(today.getTime() - date1.getTime());
		var daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24)); 	

		return 	(daysLeft==1) ? daysLeft + " day left" : daysLeft + " days left";
	}

	pushItemToList(list, item){
		list.push(item);
	}

	removeItemFromList(list, attributeName, item){
		for (var i = list.length - 1; i >= 0; i--) {
			if(list[i][attributeName] == item[attributeName]){
				list.splice(i, 1);
				break;
			}
		}
	}	

	concatenateList(list, attributeName, delimiter){
		var returnVal="";

		for (var i = 0; i < list.length; ++i) {
			returnVal += list[i][attributeName] + 
						 ((i == list.length-1) ? "" : delimiter );
		}

		return returnVal;
	}	

	concatenateListNoAttribute(list, delimiter){
		var returnVal="";

		for (var i = 0; i < list.length; ++i) {
			returnVal += list[i] + 
						 ((i == list.length-1) ? "" : delimiter );
		}

		return returnVal;
	}		

	returnItemFromList(list, attributeName, compareValue){
		let returnVal: any ={};

		for (var i = 0; i < list.length; ++i) {
			if(list[i][attributeName] == compareValue){
				returnVal = list[i];
				break;
			}
		}		

		return returnVal;
	}

	filterList(q, list, searchField) {
		let filter = q.replace(' ', '').toLowerCase();

		return list.filter((item)=>{
			let cleanStr = item[searchField].replace(' ', '').toLowerCase();

			return cleanStr.indexOf(filter)>=0;
		});
	}	

	businessIsAvailable(scheduleJSON) {
		var parsedSchedule = JSON.parse(scheduleJSON);

		var today = new Date();

		var day = this.weekDays.filter(function (el) {
        	return (el.Id === today.getDay());
      	});

		var daySchedule = parsedSchedule.schedule.find(function (el) {
	        return (el.day === day[0].Day);
	    });

	    var time = new Date(today.toLocaleDateString() + ' ' + daySchedule.from);
		var nextTime = new Date(today.toLocaleDateString() + ' ' + daySchedule.to);

		var isOpen = (time.getTime() <= today.getTime() && today.getTime() <= nextTime.getTime())

		return isOpen;
	}

	weekDays: any = [
 		{
 			Id: 0,
 			Day: "Sunday"
 		},
 		{
 			Id: 1,
 			Day: "Monday"
 		},
 		{
 			Id: 2,
 			Day: "Tuesday"
 		},
 		{
 			Id: 3,
 			Day: "Wednesday"
 		},
 		{
 			Id: 4,
 			Day: "Thursday"
 		},
 		{
 			Id: 5,
 			Day: "Friday"
 		},
 		{
 			Id: 6,
 			Day: "Saturday"
 		},
 	]

	generateUUID() {
	  let
	    d = new Date().getTime(),
	    d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
	    let r = Math.random() * 16;
	    if (d > 0) {
	      r = (d + r) % 16 | 0;
	      d = Math.floor(d / 16);
	    } else {
	      r = (d2 + r) % 16 | 0;
	      d2 = Math.floor(d2 / 16);
	    }
	    return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
	  });
	} 	

	convertMinsToHrsMins(mins){
	  let h = Math.floor(mins / 60);
	  let m = mins % 60;
	  
	  h = h < 10 ? h : h; // (or alternatively) h = String(h).padStart(2, '0')
	  m = m < 10 ? m : m; // (or alternatively) m = String(m).padStart(2, '0')

	  var returnString = "";

	  if(h==0){	  
	  	if(m>1){
	  		returnString = m + " minutes"
	  	}else{
	  		returnString = m + " minute"
	  	}
	  }else if (h!=0 && m==0){
	  	if(h>1){
	  		returnString = h + " hours"	
	  	}else{
	  		returnString = h + " hour"
	  	}	  	
	  }else if (h!=0 && m!=0){
	  	if(h>1){
	  		returnString = h + " hours"	
	  	}else{
	  		returnString = h + " hour"
	  	}	 

	  	if(m>1){
	  		returnString = returnString + " and " + m + " minutes"
	  	}else{
	  		returnString = returnString + " and " + m + " minute"
	  	}
	  }

	  return returnString;
	}	

	roundDecimalUp(number){
		return Math.round((number + Number.EPSILON) * 100) / 100; 
	}	
}

